import { Monitor, Moon, Sun } from 'lucide-react';
import { useTheme } from '@/app/providers/ThemeProvider';
import { Button } from '@/components/common/Button';

const NEXT_LABEL = {
  light: 'Switch to dark theme',
  dark: 'Follow system theme',
  system: 'Switch to light theme',
} as const;

/**
 * Cycles light → dark → system.
 *
 * A three-state cycle rather than a two-state switch because "follow the OS" is
 * a genuinely different choice from "always light", and a binary toggle silently
 * throws it away the first time it is pressed.
 */
export function ThemeToggle() {
  const { preference, cycle } = useTheme();

  const Icon = preference === 'light' ? Sun : preference === 'dark' ? Moon : Monitor;

  return (
    <Button
      variant="ghost"
      size="icon"
      onClick={cycle}
      aria-label={NEXT_LABEL[preference]}
      title={NEXT_LABEL[preference]}
    >
      <Icon className="h-4 w-4" aria-hidden="true" />
    </Button>
  );
}
